import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-chevron-double-down-icon',
  imports: [],
  templateUrl: './chevron-double-down-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './chevron-double-down-icon.component.scss',
})
export class ChevronDoubleDownComponent {}
